/**
 * 后台管理
 * **/

import project from './project'
import device from './device'
import product from './product'
import user from './user'
import role from './role'
import verion from './verion'
import template from './template'
import vender from './vender'
import task from './task'
import log from './log'
// import detection from './etection'
import userProjects from './userProjects'
import home from './home'
const adminApi = {
  //项目管理
  project: {
    ...project
  },
  //设备管理
  device: {
    ...device
  },
  //产品类型
  product: {
    ...product
  },
  //用户管理
  user: {
    ...user
  },
  //角色管理
  role: {
    ...role
  },
  //版本管理
  verion: {
    ...verion
  },
  // 模板管理
  template: {
    ...template
  },
  // 厂家管理
  vender:{
    ...vender
  },
  //任务列表
  task: {
    ...task
  },
  //系统日志列表
  log: {
    ...log
  },
  userProjects:{
	...userProjects
  },
  home:{
	...home
  }
}

export default adminApi
